import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SubHeading, MenuItem } from '../../components';
import { data, images } from '../../constants';
import {motion} from 'framer-motion'

import './SpecialMenu.css';

const SpecialMenu = () => {
  let navigate = useNavigate();


  return (
  <div className="app__specialMenu flex__center section__padding" id="menu">
    <div className="app__specialMenu-title">
      <SubHeading title="Menu that fits your palatte" divCentrado={1} />
      {/* <h1 className="headtext__cormorant">Today&apos;s Special</h1> */}
      <h1 className="headtext__cormorant">Special Menu</h1>
    </div>

    <div className="app__specialMenu-menu">
      <div className="app__specialMenu-menu_wine  flex__center">
        <p className="app__specialMenu-menu_heading">Pastries</p>
        <div className="app__specialMenu_menu_items">
          {data.wines.map((wine, index) => (
            <MenuItem key={wine.title + index} title={wine.title} price={wine.price} tags={wine.tags} />
          ))}
        </div>
      </div>

      <div className="app__specialMenu-menu_img">
        <img src={images.cakeSpecialMenu} alt="menu__img" />
      </div>

      <div className="app__specialMenu-menu_cocktails  flex__center">
        <p className="app__specialMenu-menu_heading">Drinks</p>
        <div className="app__specialMenu_menu_items">
          {data.cocktails.map((cocktail, index) => (
            <MenuItem key={cocktail.title + index} title={cocktail.title} price={cocktail.price} tags={cocktail.tags} />
          ))}
        </div>
      </div>
    </div>

    <div style={{ marginTop: 15 }}>
      <motion.button whileTap={{ scale: 0.9 }} type="button" className="custom__button" onClick={() => {navigate('/menu')}}>View More</motion.button>
    </div>
  </div>
)
}

export default SpecialMenu;
